import { IconButton, IconButtonStyles, Icons } from '@silverfort/sf-components';
import { FC, SVGProps } from 'react';

type Props = {
    collapsed: boolean;
    onToggle: () => void;
};

const CategoriesHeader: FC<Props> = ({ collapsed, onToggle }) => {
    const toggleIcon = collapsed ? Icons.PanelLeftOpen : Icons.PanelLeftClose;

    return (
        <div
            className={`h-12 w-fit min-w-12 max-w-50 px-2 border-e border-sf-gray-100 flex items-center ${
                collapsed ? 'justify-center' : 'justify-between gap-2'
            }`}>
            <span
                className={`h-4 font-sf font-medium text-[13px] leading-[15.87px] overflow-hidden transition-[width] ease-in duration-[225ms] ${
                    collapsed ? 'w-0' : 'w-38'
                }`}>
                Categories
            </span>
            <IconButton
                iconSize={20}
                className="p-0.5"
                iconClassName="text-sf-gray-400"
                buttonStyle={IconButtonStyles.Secondary}
                icon={toggleIcon as FC<SVGProps<SVGSVGElement>>}
                onClick={onToggle}
            />
        </div>
    );
};

export default CategoriesHeader;
